import CancelIcon from '@mui/icons-material/Cancel'
import CheckIcon from '@mui/icons-material/CheckCircle'
import InfoIcon from '@mui/icons-material/Info'
import WarningIcon from '@mui/icons-material/Warning'
import { useTheme } from '@mui/material/styles'
import { useCallback } from 'react'
import toast, { ToastOptions } from 'react-hot-toast'

export const useThemedToast = () => {
    const theme = useTheme()

    const showError = useCallback((message: string, options?: ToastOptions) => {
        return toast.error(message, {
            duration: 3000,
            icon: <CancelIcon sx={{ color: theme.palette.neutral.white }} onClick={() => toast.dismiss(options?.id)} />,
            style: {
                borderRadius: theme.shape.borderRadius,
                background: theme.palette.error.main,
                color: theme.palette.neutral.white,
                fontSize: '14px',
                fontWeight: 500,
                boxShadow: theme.shadows[4],
                fontFamily: theme.typography.fontFamily
            },
            iconTheme: {
                primary: theme.palette.error.contrastText,
                secondary: theme.palette.error.main
            },
            ...options
        })
    }, [])

    const showSuccess = useCallback((message: string, options?: ToastOptions) => {
        return toast.success(message, {
            duration: 3000,
            icon: (
                <CheckIcon
                    sx={{ color: theme.palette.success.contrastText }}
                    onClick={() => toast.dismiss(options?.id)}
                />
            ),
            style: {
                borderRadius: theme.shape.borderRadius,
                background: theme.palette.success.main,
                color: theme.palette.neutral.white,
                fontSize: '14px',
                fontWeight: 500,
                boxShadow: theme.shadows[4],
                fontFamily: theme.typography.fontFamily
            },
            iconTheme: {
                primary: theme.palette.success.contrastText,
                secondary: theme.palette.success.main
            },
            ...options
        })
    }, [])

    const showWarning = useCallback((message: string, options?: ToastOptions) => {
        return toast(message, {
            duration: 3000,
            icon: (
                <WarningIcon
                    sx={{ color: theme.palette.warning.contrastText }}
                    onClick={() => toast.dismiss(options?.id)}
                />
            ),
            style: {
                borderRadius: theme.shape.borderRadius,
                background: theme.palette.warning.main,
                color: theme.palette.neutral.black,
                fontSize: '14px',
                fontWeight: 500,
                boxShadow: theme.shadows[4],
                fontFamily: theme.typography.fontFamily
            },
            ...options
        })
    }, [])

    const showInfo = useCallback((message: string, options?: ToastOptions) => {
        return toast(message, {
            duration: 3000,
            icon: (
                <InfoIcon sx={{ color: theme.palette.info.contrastText }} onClick={() => toast.dismiss(options?.id)} />
            ),
            style: {
                borderRadius: theme.shape.borderRadius,
                background: theme.palette.neutral.black,
                color: theme.palette.neutral.white,
                fontSize: '14px',
                fontWeight: 500,
                boxShadow: theme.shadows[4],
                fontFamily: theme.typography.fontFamily
            },
            iconTheme: {
                primary: theme.palette.neutral.white,
                secondary: theme.palette.neutral.white
            },
            ...options
        })
    }, [])

    return {
        showError,
        showSuccess,
        showWarning,
        showInfo
    }
}
